import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  OnInit,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EmperorCardTypes } from '@boldpenguin/emperor-presentational';
import { environment } from '@environments/environment';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { BpSdkCoreService } from 'src/app/core/services/bp-sdk-core-service/bp-sdk-core.service';
import { selectRedirectPath } from 'src/app/core/store/redirect/redirect.selectors';
import { getCustomSubdomain } from 'src/app/shared/utilities/url-utilities';
import { getRedirectUri } from '../../utilities/redirect-utilities';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-logged-out',
  templateUrl: './logged-out.component.html',
  styleUrls: ['./logged-out.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoggedOutComponent implements OnInit {
  readonly EmperorCardTypes = EmperorCardTypes;
  logoutSuccess$: Observable<boolean>;

  constructor(
    private readonly store: Store,
    private readonly bpSdkCoreService: BpSdkCoreService,
    private route: ActivatedRoute,
    private destroyRef: DestroyRef,
  ) {}

  ngOnInit(): void {
    this.logoutSuccess$ = this.route.queryParams.pipe(
      map((params) => !!params.success),
    );
  }

  gotoUnifiedAuth(): void {
    this.store
      .pipe(select(selectRedirectPath))
      .pipe(take(1), takeUntilDestroyed(this.destroyRef))
      .subscribe((redirectPath) => {
        const subdomain = getCustomSubdomain(
          window.location.hostname,
          window.location.search,
          environment.envTag,
        );

        const redirectUri = getRedirectUri(redirectPath);
        this.bpSdkCoreService.loginUnified(redirectUri, subdomain);
      });
  }
}
